export default __webpack_public_path__ + "static/images/af48dbb76a6ce4ccc69c13103103c4b4.png";